import { render, staticRenderFns } from "./BlockVariants.vue?vue&type=template&id=0a5031f1&"
import script from "./BlockVariants.vue?vue&type=script&lang=js&"
export * from "./BlockVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports